import { configureStore } from '@reduxjs/toolkit'
import adventuresReducer from '../features/adventure/View/ViewAdventuresSlice'
import replyAdventureReducer from '../features/adventure/Reply/ReplyAdventureSlice'
import createAdventureReducer from '../features/adventure/Create/CreateAdventureSlice'
import inventoryReducer from '../pages/Characters/ViewSheet/characterSheetSlice'

const syncWithDatabase = (store) => (next) => (action) => {
  const { type, payload } = action
}

export const store = configureStore({
  reducer: {
    adventures: adventuresReducer,
    replyAdventure: replyAdventureReducer,
    createAdventure: createAdventureReducer,
    inventory: inventoryReducer,
  },
})
